import { render, staticRenderFns } from "./LazyCompareSimilarCarousel.vue?vue&type=template&id=01d66a44"
import script from "./LazyCompareSimilarCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyCompareSimilarCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LazyCompareSimilarCarousel.vue?vue&type=style&index=0&id=01d66a44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports